var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-page" },
    [
      _c("b-container", [
        _c("h1", [_vm._v("Geheimhaltungserklärung")]),
        _vm._v(" "),
        _c("div", [_vm._v("In Arbeit...")])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }